import { templateCriteria, } from './helpers'

export default {
  expertMode: false,
  loading: false,
  tableLoading: false,
  showResults: false,
  searchError: false,
  total: 0,
  publishDate: null,
  heightOfTableBody: 300,
  historicalDate: {
    dateOne: '',
    dateTwo: '',
  },
  items: [],
  filters: null,
  simpleFilters: null,
  searchCategory: null,
  fulltextFilter: { id: null, },
  simpleSearch: '',
  currentPage: null,
  sortedBy: {
    desc: false,
    field: '',
  },
  perPage: null,
  lastPage: null,
  checkedItems: {},
  showExportModal: false,
  exportFormat: '',
  criteria: [ templateCriteria(), ],
  relationships: [
    {
      label: 'LEI Records',
      id: 'FILTER_LEIREC',
    },
    {
      label: 'Ultimate Parent',
      id: 'FILTER_LEIREC_ULTIMATE_PARENT',
    },
    {
      label: 'Direct Parent',
      id: 'FILTER_LEIREC_DIRECT_PARENT',
    },
    {
      label: 'Ultimate Children',
      id: 'FILTER_LEIREC_ULTIMATE_CHILDREN',
    },
    {
      label: 'Direct Children',
      id: 'FILTER_LEIREC_DIRECT_CHILDREN',
    },
    {
      label: 'Fund Manager',
      id: 'FILTER_LEIREC_FUND_MANAGER',
    },
    {
      label: 'Managed Funds',
      id: 'FILTER_LEIREC_MANAGED_FUNDS',
    },
    {
      label: 'Master Fund',
      id: 'FILTER_LEIREC_MASTER_FUND',
    },
    {
      label: 'Feeder Funds',
      id: 'FILTER_LEIREC_FEEDER_FUNDS',
    },
    {
      label: 'Umbrella Fund',
      id: 'FILTER_LEIREC_UMBRELLA_FUND',
    },
    {
      label: 'Sub Funds',
      id: 'FILTER_LEIREC_SUB_FUNDS',
    },
    {
      label: 'Branches',
      id: 'FILTER_LEIREC_BRANCHES',
    },
    {
      label: 'Head Office',
      id: 'FILTER_LEIREC_HEAD_OFFICE',
    },
  ],
}



// WEBPACK FOOTER //
// ./src/store/modules/search/state.js